import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CONSTANTS } from '../constants/users.constants';
import { environment } from 'src/environments/environment';
import { GENERAL_CONSTANTS } from '../core/constants/General-constants';

export interface FeatureFlagResponse {
  CODE: string;
  DATA: boolean;
  DESC: string;
}

@Injectable({
  providedIn: 'root'
})
export class PayvalidaFeatureFlagService {
  urlglobal_api_const = environment.urlglobal_api;
  private featureFlagUrl = `${this.urlglobal_api_const}/wallet/featureFlagsWallet`;
  constructor(private http: HttpClient) { }

  getFeatureFlagValue(parameter: string, flag: string, platform: string = GENERAL_CONSTANTS.PAYVALIDA_FF_PLATFORM): Observable<boolean> {
    const requestBody = {
      parameter: parameter,
      flag: flag,
      platform: platform
    };

    return this.http.post<FeatureFlagResponse>(this.featureFlagUrl, requestBody)
      .pipe(
        map(response => {
          if (response.CODE !== CONSTANTS.CODE_OK || response.DATA === undefined) {
            return response.DATA = false;
          }
          return response.DATA;
        })
      );
  }
}
